import { HandShake, theme } from '@zappyrent/hundop';
import { useTranslation } from 'react-i18next';

import HeroBanner from '../HeroBanner';

const Welcome = (): JSX.Element => {
  const { t } = useTranslation(['common']);

  return (
    <HeroBanner
      backgroundColor={theme.colors.landlord.main}
      color={theme.colors.main}
      icon={<HandShake />}
      paragraph={t('common:welcomeParagraph')}
      title={t('common:welcomeTitle')}
    />
  );
};

export default Welcome;
